import type { RequestOptions } from "ls/api/common/server";
import type { LoginAnonymousRequestModel, LoginTokenRequestModel } from "./api/user.types";
import { useIsOnPrem } from "ls/state/useIsOnPrem";
import { loginAnonymous as serverLoginAnonymous, loginToken as serverLoginToken, logout as serverLogout } from "./api/user";

export function useDiskoServerAuthentication() {
  const isOnPrem = useIsOnPrem();

  function loginToken(model: LoginTokenRequestModel, options?: RequestOptions) {
    if (isOnPrem.value) return;
    return serverLoginToken(model, options);
  }

  function loginAnonymous(model: LoginAnonymousRequestModel, options?: RequestOptions) {
    if (isOnPrem.value) return;
    return serverLoginAnonymous(model, options);
  }

  function logout() {
    if (isOnPrem.value) return;
    return serverLogout();
  }

  return {
    loginToken,
    loginAnonymous,
    logout,
  };
}
